'use client';
import { useAuthContext } from '@/contexts/auth';
import { Suspense } from 'react';
import { AnonymousProfile } from './AnonymousProfile';
import { ProfileStats } from './ProfileStat';
import { TopSkeleton } from './TopSkeleton';

export const SideBarTop = () => {
	const { isGuest, isLoading } = useAuthContext();

	if (isLoading) {
		return <TopSkeleton />;
	}

	return (
		<Suspense fallback={<TopSkeleton />}>
			<div className="pt-16.5 pb-12.5 px-7.5 border-l-0 border-r border-grey-3 text-secondary-black">
				{!isGuest ? <ProfileStats /> : <AnonymousProfile />}
			</div>
		</Suspense>
	);
};
